import { NgClass, NgIf } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MyPocketsService } from '@App/modules/choosen-history/services';
import { DialogModule } from 'primeng/dialog';
import { ColorPickerComponent } from '@Shared/components/color-picker/color-picker.component';
import { FormsModule } from '@angular/forms';
import { NoLeadingSpaceDirective } from '@App/common/directives';

@Component({
  selector: 'app-pocket-setup',
  templateUrl: './pocket-setup.component.html',
  styleUrls: ['./pocket-setup.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ColorPickerComponent,
    DialogModule,
    NgClass,
    NgIf,
    NoLeadingSpaceDirective
  ],
  encapsulation: ViewEncapsulation.None
})
export class PocketSetupComponent implements OnInit, AfterViewInit {
  @Input() detailPocketMode: string;
  @Input() pocket: { name: string; color: string; hexColor: string } | null;
  @Input() modalErrors: { newPocketName: string; newPocketColor: string };
  @Output() saveChanges: EventEmitter<{
    name: string;
    color: number;
    hexColor: string;
  }> = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @ViewChild('newPocketNameInput') newPocketNameInput: ElementRef;

  newPocketName: string | null = null;
  newPocketColor: string | null = null;
  myPocketsColors: string[];
  isColorPickerOpen: boolean;

  constructor(private myPocketsService: MyPocketsService) {}

  ngOnInit(): void {
    this.myPocketsService.getMyPocketsColor().subscribe({
      next: (response: any) => {
        this.myPocketsColors = response;
      }
    });
    this.newPocketName = this.pocket?.name ? this.pocket.name : null;
    if (this.pocket?.hexColor) {
      this.newPocketColor = this.pocket.hexColor.includes('#')
        ? this.pocket.hexColor
        : '#' + this.pocket.hexColor;
    } else if (this.pocket?.color) {
      this.newPocketColor = this.pocket.color.includes('#')
        ? this.pocket.color
        : '#' + this.pocket.color;
    } else {
      this.newPocketColor = null;
    }
  }

  ngAfterViewInit() {
    if (this.newPocketNameInput?.nativeElement) {
      setTimeout(() => {
        this.newPocketNameInput.nativeElement.focus();
      }, 500);
    }
  }

  selectNewPocketColor(color: string | null) {
    this.newPocketColor = color.includes('#') ? color.slice(1) : color;
    this.modalErrors.newPocketColor = null;
    this.newPocketSubmit();
  }

  newPocketSubmit() {
    const validate = this.detailsModalValidate();
    if (validate === 'valid') {
      const params = {
        name: this.newPocketName.trim(),
        color: 5,
        hexColor: this.newPocketColor || this.pocket.hexColor || null
      };

      this.saveChanges.emit(params);
    }
  }

  detailsModalValidate() {
    let nameMessage: string = null;
    let colorMessage: string = null;
    const errors = {
      newPocketName: null,
      newPocketColor: null
    };

    if (!this.newPocketName) {
      nameMessage = 'The name field is required';
    }

    if (this.newPocketName && this.newPocketName.length > 35) {
      nameMessage = 'Max number of characters is 35';
    }

    colorMessage = !this.newPocketColor ? 'The color field is required' : null;
    errors.newPocketName = nameMessage;
    errors.newPocketColor = colorMessage;
    this.modalErrors = { ...errors };

    return nameMessage || colorMessage ? 'invalid' : 'valid';
  }

  openColorPicker() {
    this.isColorPickerOpen = true;
  }

  closeColorPickerDialog() {
    this.cancel.emit();
    this.isColorPickerOpen = false;
  }

  createNewColor(newColor: string) {
    this.selectNewPocketColor(newColor);
    this.myPocketsColors.push(newColor.slice(1));
    this.isColorPickerOpen = false;
  }
}
